<script lang="ts">
	import type { CartState } from '../../handlers/cart_state.svelte';

	import LucideIcon from '$lib/utils/components/LucideIcon.svelte';
	import SavedAddresses from './SavedAddresses.svelte';
	import NewAddressMap from './NewAddressMap.svelte';
	import * as Tabs from '$lib/components/ui/tabs';

	import { utils } from '$lib/utils/utils.svelte';
	import { Loc } from '$lib/tools/locale.svelte';
	import { slide } from 'svelte/transition';

	let { cart_state }: { cart_state: CartState } = $props();

	const saved_addresses = $derived(
		cart_state.variables.buyer &&
			'Addresses' in cart_state.variables.buyer &&
			cart_state.variables.buyer.Addresses.length > 0
			? cart_state.variables.buyer.Addresses
			: []
	);

	const has_saved = $derived(saved_addresses.length > 0);

	let mode = $state<'saved' | 'new'>(has_saved ? 'saved' : 'new');
	let new_location = $state<{ lat: number; lng: number } | null>(null);
	let new_description = $state('');

	// Auto-switch Logic
	$effect(() => {
		if (!has_saved) mode = 'new';
		else if (has_saved && !cart_state.variables.destination && mode !== 'new') mode = 'saved';
	});

	$effect(() => {
		if (mode === 'new') {
			cart_state.variables.destination = undefined; // Reset when entering new mode
			if (new_location) {
				cart_state.variables.destination = {
					is_imported: false,
					description: new_description,
					location: utils.addresses.create_address_object({ latitude: new_location.lat, longitude: new_location.lng })
				};
			}
		}
		//  else {
		// 	cart_state.variables.destination = undefined; // Reset when switching to saved until clicked
		// }
	});
</script>

<div class="space-y-4" in:slide>
	<Tabs.Root value={mode} onValueChange={(v) => (mode = v as 'saved' | 'new')} class="w-full">
		{#if has_saved}
			<Tabs.List class="grid w-full grid-cols-2 mb-4">
				{#if has_saved}
					<Tabs.Trigger value="saved"
						>{Loc('previous_addresses')}
						{#if cart_state.variables.destination?.is_imported}
							<div class="p-0.5 bg-background rounded-full border shadow-sm">
								<LucideIcon name="Check" class="text-primary" size="8" />
							</div>
						{/if}
					</Tabs.Trigger>
				{/if}
				<Tabs.Trigger value="new"
					>{Loc('new_location')}
					{#if cart_state.variables.destination && !cart_state.variables.destination?.is_imported}
						<div class="p-0.5 bg-background rounded-full border shadow-sm">
							<LucideIcon name="Check" class="text-primary" size="8" />
						</div>
					{/if}
				</Tabs.Trigger>
			</Tabs.List>
		{/if}
		{#if has_saved}
			<Tabs.Content value="saved" class="space-y-4 mt-0">
				<SavedAddresses {cart_state} {saved_addresses} />
			</Tabs.Content>
		{/if}
		<Tabs.Content value="new" class="mt-0">
			<NewAddressMap bind:selected_location={new_location} bind:address_description={new_description} {cart_state} />
		</Tabs.Content>
	</Tabs.Root>
</div>
